import React from 'react';
import './shared.css';

function FeeSettingsInputs({
  brokerFee, setBrokerFee,
  salesTax, setSalesTax,
  sccBuy, setSccBuy,
  sccSell, setSccSell,
  disabled,
}) {
  return (
    <>
      <div className="settings-group">
        <label>Broker Fee %</label>
        <input
          type="number" min="0" max="100" step="0.01"
          value={brokerFee}
          onChange={e => setBrokerFee?.(parseFloat(e.target.value) || 0)}
          disabled={disabled}
        />
      </div>
      <div className="settings-group">
        <label>Sales Tax %</label>
        <input
          type="number" min="0" max="100" step="0.01"
          value={salesTax}
          onChange={e => setSalesTax?.(parseFloat(e.target.value) || 0)}
          disabled={disabled}
        />
      </div>
      <div className="settings-group scc-toggle">
        <label>
          <input type="checkbox" checked={sccBuy} onChange={e => setSccBuy?.(e.target.checked)} disabled={disabled} />
          SCC Surcharge on Buys (0.5%)
        </label>
      </div>
      <div className="settings-group scc-toggle">
        <label>
          <input type="checkbox" checked={sccSell} onChange={e => setSccSell?.(e.target.checked)} disabled={disabled} />
          SCC Surcharge on Sells (0.5%)
        </label>
      </div>
    </>
  );
}

export default FeeSettingsInputs;
